import React from 'react';

import Button from '@swf/components/StarsButton/StarsButton';

import { TXTWCL_Got_it } from './DismissButton.messages.json';
import styles from './DismissButton.scss';

interface Props {
  onDismiss: () => void;
}

const DismissButton: React.FC<Props> = ({ onDismiss }) => (
  <div className={styles.buttonContainer}>
    <Button
      className={styles.button}
      variant="secondary"
      translation={TXTWCL_Got_it}
      onClick={onDismiss}
    />
  </div>
);
export default DismissButton;
